






























import { Actions } from '@/store';
import { ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'ConfirmDeleteOpportunityDraftModal',
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
    };
  },
  methods: {
    async deleteOpportunityDraft() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.drafts.delete,
          this.$store.state.opportunities.drafts.current.id,
        );
        this.$bvModal.hide('delete-opportunity-draft-modal');
        ToastsService.warning(this.$t('opportunities.new.form.notifications.delete-draft-success') as string);
        this.$router.push({ name: 'opportunity' });
      } finally {
        this.loader.isRequestPending = false;
      }
    },
  },
});
